<div class="edit-image">
  <div style="height: 100%;" class="d-flex justify-content-center">
    <div class="close" style="z-index: 10000;" nz-icon nzType="close-circle" (click)="dialogRef.close()"></div>
    <!-- Phần chứa cấu hình bên trái: Chứa các mục cấu hinh -->
    <div class="col-2 toolbar">
      <div class="header" style="color:while">
        <p style="color:#aeaeae;text-transform: uppercase;">{{ 'chinh_sua_hinh_anh' | translate }}</p>
      </div>
      <div>
        <ul class="list-choose">
          <li *ngFor="let item of canvasService.listChoose; let index = index" class="item-choose"
          (click)="onChangeTab(index)" [class.active]="index == tab" [class.disabled]="menuOpenMap[item.funcName]">
            <mat-icon>{{item.icon}}</mat-icon> {{ item.title | translate }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Phần chứa cấu hình bên trái: Chứa các mục cấu hinh -->
    <div class="col-1 mt-5 tool-gr">
      <!-- Bộ tool cắt ảnh -->
      <div *ngIf="canvasService.listChoose[tab].funcName == 'cropImage'" class="tool-gr__container tool-gr__crop">
        <button mat-icon-button (click)="startCrop()" [disabled]="isCropping"
          [matTooltip]="'bat_dau_cat_anh' | translate" matTooltipPosition="after">
          <mat-icon>crop</mat-icon>
        </button>
        <button *ngFor="let ratioCrop of canvasService.ratiosCrop"
        mat-icon-button (click)="handleCrop(ratioCrop)" [disabled]="!isCropping"
        [matTooltip]="('cat_anh_theo_ti_le' | translate) + ' ' + ratioCrop" matTooltipPosition="after">
          {{ ratioCrop }}
        </button>
        <mat-form-field appearance="outline" class="zoom-input"
        [matTooltip]="'chieu_rong_vung_cat_anh' | translate" matTooltipPosition="after">
          <mat-label>{{ 'chieu_rong' | translate}}</mat-label>
          <input matInput type="number" [min]="minCrop"
            [(ngModel)]="cropCustomSize.width" [max]="image.width"
            (change)="handleCrop('custom')" [step]="0.01"
            [disabled]="!isCropping"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="zoom-input"
        [matTooltip]="'chieu_cao_vung_cat_anh' | translate" matTooltipPosition="after">
          <mat-label>{{ 'chieu_cao' | translate}}</mat-label>
          <input matInput type="number" [min]="minCrop"
            [(ngModel)]="cropCustomSize.height" [max]="image.height"
            (change)="handleCrop('custom')" [step]="0.01"
            [disabled]="!isCropping"
          />
        </mat-form-field>
        <button mat-icon-button (click)="resetCropState(); startCrop()" [disabled]="!isCropping"
          [matTooltip]="'reset_ve_mac_dinh' | translate" matTooltipPosition="after">
          <mat-icon>refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="openPopupSaveFileImg()"
          [disabled]="!isCropping && cropCustomSize.width && cropCustomSize.height && cropCustomSize.width > minCrop && cropCustomSize.height > minCrop"
          [matTooltip]="((cropCustomSize.width > minCrop && cropCustomSize.height > minCrop) ? 'luu_file_anh' : 'chieu_rong_va_chieu_cao_phai_lon_hon_10') | translate"
          matTooltipPosition="after">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="cancelCrop()" [disabled]="!isCropping"
          [matTooltip]="'huy_cat_anh' | translate" matTooltipPosition="after">
          <mat-icon>delete_sweep</mat-icon>
        </button>
        <button mat-icon-button (click)="undo()" [disabled]="image.src == originalImage?.src"
          [matTooltip]="'tra_ve_anh_truoc_khi_cat' | translate" matTooltipPosition="after">
          <mat-icon>undo</mat-icon>
        </button>
      </div>
      <!-- Bộ tool xoay ảnh -->
      <div *ngIf="canvasService.listChoose[tab].funcName == 'rotateImage'" class="tool-gr__container tool-gr__rotate">
        <button mat-icon-button (click)="handleRotate('right90')" [disabled]="rotationAngle >= 360"
        [matTooltip]="'xoay_phai_90_do' | translate" matTooltipPosition="after">
          <mat-icon [style.transform]="'scaleX(-1)'">rotate_90_degrees_ccw</mat-icon>
        </button>
        <button mat-icon-button (click)="handleRotate('right')" [disabled]="rotationAngle >= 360"
        [matTooltip]="'xoay_phai_10_do' | translate" matTooltipPosition="after">
          <mat-icon>rotate_right</mat-icon>
        </button>
        <mat-slider
          [min]="-360"
          [max]="360"
          [step]="1"
          [(ngModel)]="rotationAngle"
          (change)="rotationAngle = $event.value; handleRotate('blur')"
          [vertical]="true"
          thumbLabel
        ></mat-slider>
        <mat-form-field appearance="outline" class="zoom-input">
          <mat-label>{{ 'xoay' | translate }}</mat-label>
          <input matInput type="number" [min]="-360"
            [(ngModel)]="rotationAngle" [max]="360"
            (blur)="handleRotate('blur')" [step]="1"
          />
        </mat-form-field>
        <button mat-icon-button (click)="handleRotate('reset')" [disabled]="rotationAngle == 0"
        [matTooltip]="'reset_ve_0' | translate" matTooltipPosition="after">
          <mat-icon>refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="handleRotate('left')" [disabled]="rotationAngle <= -360"
        [matTooltip]="'xoay_trai_10_do' | translate" matTooltipPosition="after">
          <mat-icon>rotate_left</mat-icon>
        </button>
        <button mat-icon-button (click)="handleRotate('left90')" [disabled]="rotationAngle <= -360"
        [matTooltip]="'xoay_trai_90_do' | translate" matTooltipPosition="after">
          <mat-icon>rotate_90_degrees_ccw</mat-icon>
        </button>
        <button mat-icon-button (click)="openPopupSaveFileImg()" [disabled]="rotationAngle == 0"
          [matTooltip]="'luu_file_anh' | translate" matTooltipPosition="after">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="undo()" [disabled]="image.src == originalImage?.src"
          [matTooltip]="'tra_ve_anh_truoc_khi_xoay' | translate" matTooltipPosition="after">
          <mat-icon>undo</mat-icon>
        </button>
      </div>
      <!-- Bộ tool xoá nền -->
      <div *ngIf="canvasService.listChoose[tab].funcName == 'removeBackground'" class="tool-gr__container tool-gr__remove-background">
        <button mat-icon-button (click)="openPopupSaveFileImg()" [disabled]="false"
          [matTooltip]="'bat_dau_xoa_nen_anh' | translate" matTooltipPosition="after">
          <mat-icon>cancel_presentation</mat-icon>
        </button>
        <button mat-icon-button (click)="undo()" [disabled]="image.src == originalImage?.src"
          [matTooltip]="'tra_ve_anh_truoc_khi_xoa_nen' | translate" matTooltipPosition="after">
          <mat-icon>undo</mat-icon>
        </button>
      </div>
      <!-- Bộ tool vẽ ảnh -->
      <div *ngIf="canvasService.listChoose[tab].funcName == 'drawOnImage'" class="tool-gr__container tool-gr__draw-image">
        <button *ngFor="let drawTool of canvasService.drawTools"
        mat-icon-button (click)="setTool(drawTool.name)" [class.active]="currentTool === drawTool.name"
        [matTooltip]="drawTool.label | translate" matTooltipPosition="after">
          <mat-icon>{{ drawTool.matIcon }}</mat-icon>
        </button>
        <input *ngIf="currentTool !== 'eraser'"
        type="color" [(ngModel)]="currentDrawColor" (change)="setColor(currentDrawColor)"
        [matTooltip]="'chon_mau_ve' | translate" matTooltipPosition="after">
        <mat-slide-toggle *ngIf="['square', 'circle'].includes(currentTool)"
        [(ngModel)]="isDrawFilling" (change)="isDrawFilling = $event.checked">
        </mat-slide-toggle>
        <input *ngIf="isDrawFilling && ['square', 'circle'].includes(currentTool)"
        type="color" [(ngModel)]="currentDrawFillColor" (change)="setColor(currentDrawFillColor, true)"
        [matTooltip]="'chon_mau_de_to_mau_hinh_vuong_hoac_hinh_tron' | translate" matTooltipPosition="after">
        <mat-slider
          [matTooltip]="'do_day_net_ve' | translate"
          matTooltipPosition="after"
          [min]="1"
          [max]="20"
          [step]="1"
          [(ngModel)]="currentLineWidth"
          (input)="setLineWidth(currentLineWidth)"
          [vertical]="true"
          thumbLabel
        ></mat-slider>
        <span>{{currentLineWidth}}px</span>
        <button mat-icon-button (click)="undo()" [disabled]="historyIndex <= 0"
          [matTooltip]="'tra_ve_anh_truoc_khi_ve_len' | translate" matTooltipPosition="after">
          <mat-icon>undo</mat-icon>
        </button>
        <button mat-icon-button (click)="redo()" [disabled]="historyIndex >= drawingHistory.length - 1"
          [matTooltip]="'tra_ve_anh_sau_khi_ve_len' | translate" matTooltipPosition="after">
          <mat-icon>redo</mat-icon>
        </button>
        <button mat-icon-button (click)="clearCanvas()"
        [matTooltip]="'xoa_het' | translate" matTooltipPosition="after">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button (click)="openPopupSaveFileImg()" [disabled]="false"
          [matTooltip]="'luu_file_anh' | translate" matTooltipPosition="after">
          <mat-icon>save</mat-icon>
        </button>
      </div>
      <!-- Bộ tool chèn logo -->
      <div *ngIf="canvasService.listChoose[tab].funcName == 'addLogo'" class="tool-gr__container tool-gr__add-logo">
        <button mat-icon-button (click)="openPopupSaveFileImg()" [disabled]="true"
          [matTooltip]="'luu_file_anh' | translate" matTooltipPosition="after">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="undo()" [disabled]="image.src == originalImage?.src"
          [matTooltip]="'tra_ve_anh_truoc_khi_chen_logo' | translate" matTooltipPosition="after">
          <mat-icon>undo</mat-icon>
        </button>
      </div>
    </div>

    <!-- Phần chỉnh sửa ảnh: Canvas -->
    <div class="col-9 mt-5 canvas-container">
      <canvas #canvas
        tabindex='1'
        [style.width]="'100%'"
        [style.height]="'100%'"
        [style.cursor]="true ? cursorCanvas : (activeTool == 'crop' ? 'all-scroll' : (isDragging ? 'grabbing' : 'grab'))"
        (wheel)="onWheel($event)"
        (mouseleave)="onMouseUp($event)"
        (mouseup)="onMouseUp($event)"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (contextmenu)="onRightClick($event)">
      </canvas>
    </div>

    <!-- Phần điều khiển phóng to hoặc thu nhỏ ảnh ở dưới cùng để chỉnh sửa -->
    <div class="zoom-controls mat-elevation-z2" nz-tooltip [nzTooltipOverlayStyle]="{ 'max-width.vw': 80 }"
    [nzTooltipTitle]="tooltipTutorialBasic" [style.display]="allowDragAndZoom ? 'flex' : 'none'">
      <button mat-icon-button (click)="onZoom('out')" [disabled]="scale <= minScale">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <mat-slider
        [min]="minScale"
        [max]="maxScale"
        [step]="0.01"
        [(ngModel)]="scale"
        (input)="onZoomChange($event)"
        (change)="draw()"
        thumbLabel
      ></mat-slider>
      <button mat-icon-button (click)="onZoom('in')" [disabled]="scale >= maxScale">
        <mat-icon>zoom_in</mat-icon>
      </button>
    
      <mat-form-field appearance="outline" class="zoom-input">
        <mat-label>Zoom</mat-label>
        <input matInput type="number" 
          [(ngModel)]="scale" 
          (change)="onZoomChange($event)"
          [max]="maxScale"
          [min]="minScale"
          [step]="0.01"
          (blur)="draw()"
        />
      </mat-form-field>

      <button mat-icon-button (click)="onZoom('actual')"
      [matTooltip]="'kich_thuoc_goc_cua_anh' | translate"
      matTooltipPosition="above">
        <mat-icon>zoom_out_map</mat-icon>
      </button>
    
      <button mat-icon-button (click)="onZoom('fit')"
      [matTooltip]="'thu_phong_cho_vua_voi_khung_hinh' | translate"
      matTooltipPosition="above">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>

      <mat-slide-toggle [(ngModel)]="showGrid" labelPosition="before" (change)="draw()"
      [disabled]="isCropping || canvasService.listChoose[tab].funcName == 'removeBackground'">
        {{ 'luoi' | translate }}
      </mat-slide-toggle>
    </div>
  </div>
</div>

<!-- Phần modal chuyển ảnh lên server -->
<nz-modal nzTitle="{{ 'nhap_thong_tin_luu_anh_da_chinh_sua' | translate}}" [(nzVisible)]="isShowConfirmPopup" [nzContent]="modalContent"
  (nzOnCancel)="isShowConfirmPopup = false;" (nzOnOk)="save()" [nzFooter]="modalFooter">
  <ng-template #modalContent>
    <p>{{'nen_anh_tai_len' | translate}}</p>
    <nz-select style="margin-bottom: 15px" [(ngModel)]="objectChoosing.setups.upload_image.compress_type"  (ngModelChange)="updateSetups()"
      nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
      <nz-option [nzValue]="'no-compress'" nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-screen'" nzLabel="{{'nen_anh_theo_ti_le_man_hinh_hien_thi' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-frame'" nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
      <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
    </nz-select>

    <mat-form-field *ngIf="objectChoosing.setups.upload_image.compress_type == 'custom'" class="mr-4">
      <mat-label>{{'chieu_rong' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
    </mat-form-field>

    <mat-form-field *ngIf="objectChoosing.setups.upload_image.compress_type == 'custom'">
      <mat-label>{{'chieu_cao' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{'nhap_ten_file_anh' | translate}}</mat-label>
      <input matInput placeholder="{{'ten_file' | translate}}" [(ngModel)]="fileImg.name">
    </mat-form-field>

    <p>{{'nhap_duoi_file_anh' | translate}}</p>
    <nz-select style="margin-bottom: 15px" [(ngModel)]="fileImg.extension"
      (ngModelChange)="fileImg.type = canvasService.extensionToType[$event]"
      nzPlaceHolder="{{'duoi_file' | translate}}" nzAllowClear>
      <nz-option
        *ngFor="let item of canvasService.extensionToType | keyvalue"
        [nzValue]="item.key"
        [nzLabel]="(item.key.toUpperCase() + ' file') | translate"
      ></nz-option>
      <!-- <nz-option [nzValue]="'png'" nzLabel="{{'PNG file' | translate}}"></nz-option>
      <nz-option [nzValue]="'jpeg'" nzLabel="{{'JPEG file' | translate}}"></nz-option> -->
    </nz-select>

    <p>{{ 'loai_anh_khi_luu_tren_web' | translate }}: {{ canvasService.extensionToType[fileImg.extension] }}</p>
  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="isShowConfirmPopup = false;">{{'khong' | translate}}</button>
    <button nz-button nzType="primary" (click)="save()" [nzLoading]="isConfirmLoading">{{'dong_y' | translate}}</button>
  </ng-template>
</nz-modal>

<ng-template #tooltipTutorialBasic>
  <ul style="margin: 0; padding: 0; padding-left: 16px">
    <li>{{ 'co_the_dung_ctrl_cuon_chuot_de_thu_phong' | translate }}</li>
    <li>{{ 'co_the_dung_chuot_phai_de_di_chuyen' | translate }}</li>
  </ul>
</ng-template>